import { render, staticRenderFns } from "./InstrumentAuditTrailHistory.vue?vue&type=template&id=66f92350"
import script from "./InstrumentAuditTrailHistory.vue?vue&type=script&lang=js"
export * from "./InstrumentAuditTrailHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports